/*
 * @Author: ailin
 * @Date: 2022-07-01 16:25:45
 * @LastEditors: ailin
 * @LastEditTime: 2022-07-08 14:22:08
 * @Description: file content
 * @FilePath: /broadcast/src/assets/js/http.ts
 */
const vue = new window.Vue;
export default function jsonp(this: any, url: string, params: any) { //内部接口调用
    if (url.indexOf('//') == -1)
        url = '//wholesale' + process.env.VUE_APP_URI_DOMAIN + url;
    let param:any = { params: params, jsonp: 'jsoncallback' };
    if (params.jsonp)
        param.jsonp = params.jsonp;
    if (params.jsonpcallback)
        param.jsonpCallback = params.jsonpcallback;

    return new Promise((resolve:any, reject:any) => {

        vue.$http.jsonp(url, param)
        .then((data:any) => {
            let res = data.body
            if (res && res.returnCode === '0000' || res.code == '0000') {
                return resolve(res.data || res);
            } else {
                // vue.$toast({
                //     message: res.msg || res.returnMessage,
                //     position: 'bottom',
                //     className: 'topIndex',
                //     duration: 2000
                // });
                return reject(res);
            }
        },(err:any) => {
            // vue.$toast({
            //     message: '哎呀，小伙伴热情太高啦，挤爆了，逛逛在回来吧',
            //     position: 'bottom',
            //     className: 'topIndex'
            // });
            return reject(err);
        })
    })
}

export function unJsonp( url: string, params: any) { //内部接口调用
    let param:any = { params: params, jsonp: 'jsoncallback' };
    if (params.jsonp)
        param.jsonp = params.jsonp;
    if (params.jsonpcallback)
        param.jsonpCallback = params.jsonpcallback;

    return new Promise((resolve:any, reject:any) => {

        vue.$http.jsonp(url, param)
        .then((data:any) => {
            return resolve(data);
        },(err:any) => {
            return reject(err);
        })
    })
}